// Module
var code = `<div appHeaderBar>
    <header-bar-title>About First Citizens Bank</header-bar-title>
</div>
<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <div class="HOA-container">
        <div class="HOA-container__header">
            <h1 tid="pageTitle" id="pageTitle" class="HOA-container__header-text">About First Citizens Bank</h1>
        </div>
        <div class="HOA-container__content HOA-container__content--legal">
            <div class="HOA-moobank__subheader u-pH4">
                First Citizens Bank helps personal, business, commercial and wealth clients build financial strength that
                lasts. Founded in 1898 and headquartered in Raleigh, N.C., we are the largest family-controlled bank in
                the <span class="u-textNoWrap">United States,</span> providing a unique legacy of strength, stability and
                long-term thinking that has spanned generations.
                <span class="u-textNoWrap">First Citizens Bank. Forever First®</span>
            </div>
            <div class="HOA-flextable-component">
                <div class="HOA-moobank-hrule-first HOA-flextable-component__cell--100"></div>
                <div tid="mailingAddressLabel"
                     id="mailingAddressLabel"
                     class="HOA-moobank-flex-left-18">
                    Mailing Address:</div>
                <div class="HOA-moobank-flex-item HOA-content-font-18">
                    <div tid="mutualBank" id="mutualBank" class="u-textNoWrap">First-Citizens Bank & Trust Company</div>
                    <div tid="attn" id="attn" class="u-textNoWrap">Attn: Property Pay</div>
                    <div tid="streetAddress" id="streetAddress" class="u-textNoWrap">PO Box 27131</div>
                    <div tid="cityStateZip" id="cityStateZip" class="u-textNoWrap">Raleigh, NC 27611</div>
                </div>
                <div class="HOA-moobank-hrule HOA-flextable-component__cell--100"></div>
                <div tid="customerServiceLabel" id="customerServiceLabel" class="HOA-moobank-flex-left-18">
                    Customer Service:
                </div>
                <div tid="csPhoneNumber" id="csPhoneNumber" class="HOA-moobank-flex-item HOA-moobank-no-underline">
                    <a class="u-inline-block HOA-content-font-18" href="tel:1-866-800-4656" aria-label="Phone number (866) 800-4656">
                        (866) 800-4656 option 3
                    </a>
                </div>
                <div class="HOA-moobank-hrule HOA-flextable-component__cell--100"></div>
                <div tid="websiteLabel" id="websiteLabel" class="HOA-moobank-flex-left-18">Website:</div>
                <div tid="website" id="website" class="HOA-moobank-flex-item HOA-moobank-no-underline">
                    <a class="u-inline-block HOA-content-font-18"
                       (click)="tools.openUrl('https://www.firstcitizens.com/hosted/community-association-banking-customer-support')">
                        firstcitizens.com/cab
                    </a>
                </div>
                <div class="HOA-moobank-hrule HOA-flextable-component__cell--100"></div>
                <div tid="emailLabel" id="emailLabel" class="HOA-moobank-flex-left-18">Email*:</div>
                <div class="HOA-moobank-flex-item HOA-moobank-no-underline HOA-moobank-emailaddress">
                    <a tid="csEmail" id="csEmail" class="u-inline-block HOA-content-font-18" href="mailto:servicepropertypay@firstcitizens.com">
                        servicepropertypay@firstcitizens.com
                    </a>
                </div>
                <div class="HOA-moobank-flex-detail">
                    *Email is for general inquiry only. Please do not include personal information or account numbers
                    in your email. If you have an account specific question, please call customer service.
                </div>
            </div>
        </div>
    </div>
</app-page-content>`;
// Exports
module.exports = code;